import { render, staticRenderFns } from "./BannerEditor.vue?vue&type=template&id=500c50a4&"
import script from "./BannerEditor.vue?vue&type=script&lang=js&"
export * from "./BannerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports